import type { ApiQuestion } from '../../../../internalTypes';
import type { SliderMatrixStatementRow } from '../../../../types/sliderMatrix';
import { buildSimpleStatementRows } from '../matrix/buildSimpleStatementRows';

export function buildSliderMatrixRows(
  question: ApiQuestion,
  language?: string
): SliderMatrixStatementRow[] {
  const baseMin = Number(question.additional?.sliderMin ?? 0);
  const baseMax = Number(question.additional?.sliderMax ?? 10);
  const baseStep = Number(question.additional?.sliderStep ?? 1);

  const rows = buildSimpleStatementRows(question, language);

  return rows.map(row => ({
    ...row,
    min: Number.isFinite(baseMin) ? baseMin : 0,
    max: Number.isFinite(baseMax) ? baseMax : 10,
    step: Number.isFinite(baseStep) && baseStep > 0 ? baseStep : 1,
  }));
}
